module.exports = __webpack_public_path__ + "img/coupon-get-bg.af87273d.png";